import React from 'react';
import ReactDOM from 'react-dom';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import MLButton from '../MLButton/MLButton';
import Spinner from '../LazyWidgets/Spinner';
import styles from './ExportDialog.module.css';

const ExportDialog = ({
  show,
  onClose,
  onExport,
  onCancel,
  isLoading,
  title,
  description,
  loadingMessage,
  confirmExportTestId,
  cancelExportTestId,
  cancelDuringExportTestId,
}) => {
  if (!show) return null;

  const renderDialogTitle = () => {
    return (
      <DialogTitle className={styles.dialogTitle} disableTypography>
        <Typography
          id="export-dialog-title"
          className={styles.titleText}
          component="div"
        >
          {title}
        </Typography>
        <IconButton
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close dialog"
          data-testid="export-dialog-close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
    );
  };

  const renderDialogContent = () => {
    return (
      <DialogContent className={styles.dialogContent}>
        {isLoading ? (
          <div className={styles.loadingContainer}>
            <Spinner className={styles.spinner} />
            <Typography
              id="export-dialog-description"
              className={styles.dialogContentBodyLoading}
            >
              {loadingMessage}
            </Typography>
          </div>
        ) : (
          <Typography
            id="export-dialog-description"
            className={styles.dialogContentBody}
          >
            {description}
          </Typography>
        )}
      </DialogContent>
    );
  };

  const renderDialogActions = () => {
    return (
      <DialogActions className={styles.dialogActions}>
        {isLoading ? (
          <MLButton
            onClick={onCancel}
            btnType="secondaryRed"
            btnText="Cancel Export"
            className={styles.cancelExportButton}
            aria-label="Cancel Export"
            testId={cancelDuringExportTestId}
          />
        ) : (
          <>
            <MLButton
              onClick={onCancel}
              btnType="secondary"
              btnText="Cancel"
              aria-label="Cancel"
              testId={cancelExportTestId}
            />
            <MLButton
              onClick={onExport}
              btnType="primary"
              btnText="Export"
              aria-label="Export"
              testId={confirmExportTestId}
            />
          </>
        )}
      </DialogActions>
    );
  };

  const dialog = (
    <Dialog
      open={true}
      onClose={onClose}
      className={styles.dialog}
      aria-labelledby="export-dialog-title"
      aria-describedby="export-dialog-description"
      data-testid="export-dialog"
    >
      {renderDialogTitle()}
      {renderDialogContent()}
      {renderDialogActions()}
    </Dialog>
  );

  return ReactDOM.createPortal(dialog, document.body);
};

export default ExportDialog;
